export default "__VITE_ASSET__451278f7__"